module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    class: {
      'uk-form': true,
      'uk-form-stacked': _vm.stacked,
      'uk-form-horizontal': _vm.horizontal
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3de25848!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UkForm.vue
// module id = 288
// module chunks = 2